<section class="seo-service">
    <div class="container-fluid py-5">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        {{"Designing mobile applications and smart phones" | translate}}
                    </h2>
                    <p>
                        {{"In Codes Roots, we provide a design and programming service for smart mobile applications Android and iPhone for companies, individuals and institutions with high quality and a control panel for each application according to the need. The success of the application after uploading it to the Google market or the App Store." | translate}}
                    </p>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/app-image-1.png" alt="seo" />
            </div>
        </div>
    </div>
</section>